import React from "react";
import { LuArmchair, LuCircle, LuCircleDot, LuDoorOpen, LuEqual, LuHourglass, LuUser, LuUtensils, LuX } from "react-icons/lu";

// Shared by reservation rows and their summary; counts and colours stay with
// the caller, while every status uses the same outline and optical size.
export const reservationStatusIcons = {
  "A CHEGAR": LuHourglass,
  ATRASADA: LuHourglass,
  "À PORTA": LuDoorOpen,
  REST: LuUtensils,
  CLIENTE: LuUser,
  ESPERA: LuHourglass,
  FINALIZADA: LuArmchair,
  "Mesa livre": LuCircle,
  CANCELADAS: LuX,
  TOTAL: LuEqual,
};

export default function ReservationStatusIcon({ status, ...props }) {
  const Icon = reservationStatusIcons[status] || LuCircleDot;
  return <Icon size={18} strokeWidth={1.75} aria-hidden="true" {...props} />;
}
